import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" {...props}><path id="svg528__X" fill="currentcolor" d="M1814 128.507l-16.01-16.007L1814 96.49l-1.49-1.49-16.01 16.009L1780.49 95l-1.49 1.49 16 16.009-16 16.008 1.49 1.493 16.01-16.008L1812.51 130z" transform="translate(-1779 -95)" /></svg>);